"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_document__xls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "020c9813-1ed9-4906-9709-4dd9582177e1",
    x1: 125.08,
    y1: 44.36,
    x2: 159.64,
    y2: 78.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "document-xls-hi"), /*#__PURE__*/React.createElement("g", {
    id: "86abfc0c-0992-498a-a230-e654570fd2a1",
    "data-name": "document-xls-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "346e7dad-fd04-4d82-9a95-71d8f6ccae76",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6abdaa38-424a-42ac-a631-571403cc3b64",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c8722857-cea1-4182-a77b-b2244ec21c7f",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "82a8f531-cc81-4f4e-a6a2-9377aa51b77e",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1e246bac-2a29-44fd-ade9-7f3c22197080",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ccdf5e16-5114-4add-b709-a9c22ff196aa",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1ce88494-3b12-4c5a-a444-5c3df818e66e",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6e604b48-cdb0-436d-b4bb-3171839c10e7",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0fbb25d9-0609-4fdd-bfc3-c9dbe3380012",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "91ad7d70-3788-4343-9810-13a4b6b623d3",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "373db0b1-9dca-4722-b942-55a0e7a21c2d",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "130d9438-f288-4e58-969c-f0c588ca7fbf",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9c89b664-8099-43ef-a48d-b0c4e8da6aea",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f3d4558a-68a3-4389-97cc-1e66d24b98ff",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b13e548e-a520-4b72-9d3f-cefe4f24ea8d",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "82e045cb-1a4f-465e-aca0-f3aa8e484dbf",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6fc3b0ba-631c-4cfe-8029-fbe44cb2d669",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aae020c0-6785-42fa-a4ce-b99b4ccb64f1",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8a47a313-47f5-46c1-8990-be29cc9e3e34",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c5386d75-437e-4b97-b8a3-b53a21ab4ae9",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3b70e1b1-371b-4de5-8da2-1b2a3ed7a932",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4fe425bb-d709-4258-a3e6-51c786dc3239",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ae303452-9adb-4b26-a81b-b474bb3b1f77",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "57b0e90f-96da-45d3-a250-4044686a3740",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4f7c1294-8c71-4fd3-96d2-cbfe1561c824",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0592ad28-6335-4471-b170-38dea6a4d97e",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "30130e59-f26c-4718-90f6-9580a3741b94",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3a286d7d-0fc0-4e8f-888c-04c9094d76f1",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,44V160h0a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16h0V56H128a16,16,0,0,1-16-16V16H56A16,16,0,0,0,40,32V44",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,56H128a16,16,0,0,1-16-16V16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,54a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h24l-2-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,56c-.53,0-1.05,0-1.57-.08l-.62-.09c-.3,0-.6-.08-.89-.14s-.53-.12-.79-.19l-.65-.17c-.3-.09-.6-.2-.9-.3l-.47-.17c-.33-.13-.65-.28-1-.43l-.32-.16c-.35-.17-.68-.36-1-.56l-.2-.12q-.54-.33-1-.7l-.09-.07c-.36-.27-.71-.55-1-.84h0L152,86.56V56Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#020c9813-1ed9-4906-9709-4dd9582177e1)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,125.58a2.73,2.73,0,0,1-2.3-1,3.45,3.45,0,0,1-.77-2.17,3.52,3.52,0,0,1,.77-2.21,2.73,2.73,0,0,1,2.3-1,2.67,2.67,0,0,1,2.28,1,3.59,3.59,0,0,1,.75,2.21,3.52,3.52,0,0,1-.75,2.17A2.67,2.67,0,0,1,57.06,125.58Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.66,125.1l9-15.21-8.42-14h6.36l5.08,8.9,5-8.9h6.36l-8.37,14,9,15.21H79.5L73.72,115,67.93,125.1Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,125.1V95.87h5.61V119.8h13.59v5.3Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.31,125.72a17.61,17.61,0,0,1-3.66-.35,22.36,22.36,0,0,1-2.91-.81,14.13,14.13,0,0,1-2.13-.94,10.81,10.81,0,0,1-1.25-.79l2.37-4.87a11.38,11.38,0,0,0,1.1.83,11.22,11.22,0,0,0,1.64.92,11.1,11.1,0,0,0,2.15.72,11.5,11.5,0,0,0,2.65.29,5.34,5.34,0,0,0,3.31-.92,2.93,2.93,0,0,0,1.21-2.45,5.25,5.25,0,0,0-.22-1.6,2.89,2.89,0,0,0-.9-1.27,7.62,7.62,0,0,0-1.93-1.14q-1.25-.55-3.31-1.25a17,17,0,0,1-4.78-2.24,6.22,6.22,0,0,1-2.41-3,10.56,10.56,0,0,1-.57-3.48A8,8,0,0,1,112,98.76,7,7,0,0,1,115.71,96a15,15,0,0,1,4.73-.77,13.88,13.88,0,0,1,5,.79,11.14,11.14,0,0,1,3.16,1.71,18.62,18.62,0,0,1,1.62,1.49l-2.94,3.9a7.93,7.93,0,0,0-1.8-1.45,11,11,0,0,0-2.61-1.14,9.3,9.3,0,0,0-2.61-.44,4.53,4.53,0,0,0-3.2.9,2.92,2.92,0,0,0-.92,2.17,2.7,2.7,0,0,0,1.07,2.32,21.38,21.38,0,0,0,4.54,2.06,24.33,24.33,0,0,1,5.5,2.7,6.61,6.61,0,0,1,2.5,3.11,11,11,0,0,1,.64,3.75,7.71,7.71,0,0,1-1.8,5.15,8.36,8.36,0,0,1-4.1,2.78A15.24,15.24,0,0,1,120.31,125.72Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,174H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  })))))))))))))))))))))))))))))));
}

var _default = ic_document__xls;
exports.default = _default;